import { CSSProperties, useMemo, useState } from "react";

import { cn } from "@/lib/cn";
import { StaticEntityType } from "@config";
import { Wrapper } from "../Button.styles";
import { PAGE_URL } from "../constants";
import "../styles/_main.scss";
import { DefaultProps } from "../types";
import { preventRender } from "../utils";
import { Element } from "./Element";

export const AcceptButtonLibraryPdf = ({
  entity,
}: {
  entity: StaticEntityType;
}) => {
  const [submitted, setSubmitted] = useState(false);
  const { settings, id } = entity as StaticEntityType<DefaultProps>;
  const isEmpty = useMemo(() => preventRender({ id }), [id]);
  const width = settings.width;
  if (isEmpty) return null;

  return (
    <>
      <Wrapper
        href={PAGE_URL}
        as="a"
        target="_blank"
        rel="noopener noreferrer"
        $align={settings.horizontalAlignment}
        style={
          {
            "--resize-width": `${submitted ? "100" : width}%`,
          } as CSSProperties
        }
        className="accept-button-71d72f0d-8486-4d9d-b58c-a5b9facf4701"
      >
        <div
          className={cn(
            "accept-button__wrapper-inner tw-w-[var(--resize-width)]",
            {
              "max-md:tw-w-[80%]": Number(width) < 80,
              "max-max:tw-w-[var(--resize-width)]": Number(width) >= 80,
            },
          )}
        >
          <Element
            id={id}
            settings={settings}
            setSubmittedState={() => setSubmitted(true)}
          />
        </div>
      </Wrapper>
    </>
  );
};
